<template>
    <div>
        <a @click.prevent="ShowEdit()" href="#"><i class="fa fa-edit"></i></a>
        <modal :show.sync="modalEdit"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-xl">
            <base-header class="header pb-2 pb-2 pt-5 pt-md-8 d-flex align-items-center">
                <span class="mask bg-gradient-login_varient opacity-8"></span>
            </base-header>
            <div class="container-fluid mt--7">
                <div class="row">
                    <div class="col-xl-6">
                        <card shadow type="secondary">
                            <div slot="header" class="bg-white border-0">
                                <div class="row align-items-center">
                                    <div class="col-8">
                                        <h3 class="mb-0">Modifier cette facture</h3>
                                    </div>
                                </div>
                            </div>
                            <template>
                                <form @submit.prevent>
                                    <h6 class="heading-small text-muted mb-4">Informations Générales</h6>
                                    <div class="pl-lg-4">
                                        <div class="row">
                                            <div class="col-lg-4">
                                                <base-input alternative=""
                                                            label="Numéro de facture"
                                                            placeholder="Numéro"
                                                            input-classes="form-control-alternative"
                                                            :required="required"
                                                            v-model="facture.numero"/>
                                                <transition name="fade">
                                                    <div  v-if="numeroMissing" 
                                                        class="alert alert-danger" 
                                                        role="alert">
                                                        Le numéro est manquant.
                                                    </div>
                                                </transition>
                                            </div>
                                            <div class="col-lg-4">
                                                <base-input label="Date" :required="required">
                                                    <flat-picker slot-scope="{focus, blur}"
                                                                @on-open="focus"
                                                                @on-close="blur"
                                                                :config="{allowInput: true, dateFormat: 'Y-m-d',}"
                                                                placeholder="Date de la facture"
                                                                v-model="facture.date"
                                                                class="form-control form-control-alternative datepicker"/>
                                                </base-input>
                                                <transition name="fade">
                                                    <div  v-if="dateMissing" 
                                                        class="alert alert-danger" 
                                                        role="alert">
                                                        La Date est manquante.
                                                    </div>
                                                </transition>
                                            </div>
                                            <div class="col-lg-4">
                                                <base-input label="Fournisseur"
                                                            input-classes="form-control-alternative"
                                                            :required="required">
                                                    <InputSelect :options="fournisseur"
                                                                v-model="facture.idFournisseur"
                                                                textProp="nom"
                                                                valueProp="idFournisseur"
                                                                :searchable="searchable"
                                                                class="form-control form-control-alternative"/>
                                                </base-input>
                                                <transition name="fade">
                                                    <div  v-if="fournisseurMissing" 
                                                        class="alert alert-danger" 
                                                        role="alert">
                                                        Le fournisseur est manquant.
                                                    </div>
                                                </transition>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="my-4" />
                                    <h6 class="heading-small text-muted mb-4">Informations Réglements</h6>
                                    <div class="pl-lg-4"> 
                                        <div class="row">
                                            <div class="col-lg-4">
                                                <base-input alternative=""
                                                            label="Montant HT"
                                                            placeholder="Montant HT"
                                                            input-classes="form-control-alternative"
                                                            :required="required"
                                                            v-model="facture.montantHT"/>
                                                <transition name="fade">
                                                    <div  v-if="montanthtMissing" 
                                                        class="alert alert-danger" 
                                                        role="alert">
                                                        Le montant HT est manquant.
                                                    </div>
                                                </transition>
                                            </div>
                                            <div class="col-lg-4">
                                                <base-input alternative=""
                                                            label="Montant TTC"
                                                            placeholder="Montant TTC"
                                                            input-classes="form-control-alternative"
                                                            :required="required"
                                                            v-model="facture.montantTTC"/>
                                                <transition name="fade">
                                                    <div  v-if="montantttcMissing" 
                                                        class="alert alert-danger" 
                                                        role="alert">
                                                        Le montant TTC est manquant.
                                                    </div>
                                                </transition>
                                            </div>
                                            <div class="col-lg-4">
                                                <base-input label="Devise"
                                                            input-classes="form-control-alternative"
                                                            :required="required">
                                                    <InputSelect :options="devise"
                                                                v-model="facture.idDevise"
                                                                textProp="nom"
                                                                valueProp="idDevise"
                                                                :searchable="searchable"
                                                                class="form-control form-control-alternative"/>
                                                </base-input>
                                                
                                            </div>
                                                <transition name="fade">
                                                    <div  v-if="deviseMissing" 
                                                        class="alert alert-danger" 
                                                        role="alert">
                                                        La devise est manquante.
                                                    </div>
                                                </transition>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <base-input label="Date de réglement maximum" input-classes="form-control-alternative" :required="required">
                                                    <flat-picker slot-scope="{focus, blur}"
                                                                @on-open="focus"
                                                                @on-close="blur"
                                                                :config="{allowInput: true, dateFormat: 'Y-m-d',}"
                                                                placeholder="Date de réglement maximum de la facture"
                                                                class="form-control form-control-alternative datepicker"
                                                                v-model="facture.dateReglementMax"/>
                                                </base-input>
                                                <transition name="fade">
                                                    <div  v-if="reglementmaxMissing" 
                                                        class="alert alert-danger" 
                                                        role="alert">
                                                        La date de réglement maximum est manquante.
                                                    </div>
                                                </transition>
                                            </div>
                                            <div class="col-lg-6">
                                                <base-input label="Date de réglement effectué">
                                                    <flat-picker slot-scope="{focus, blur}"
                                                                @on-open="focus"
                                                                @on-close="blur"
                                                                :config="{allowInput: true, dateFormat: 'Y-m-d',}"
                                                                placeholder="Date de réglement de la facture"
                                                                v-model="facture.dateReglement"
                                                                class="form-control form-control-alternative datepicker"/>
                                                </base-input>
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="my-4" />
                                    <h6 class="heading-small text-muted mb-4">Etat</h6>
                                    <div class="pl-lg-4"> 
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <base-input label="Etat Réception"
                                                            input-classes="form-control-alternative"
                                                            :required="required">
                                                    <InputSelect :options="etatreception"
                                                                v-model="facture.idEtatReception"
                                                                textProp="label"
                                                                valueProp="idEtatReception"
                                                                :searchable="searchable"
                                                                class="form-control form-control-alternative"/>
                                                </base-input>
                                                <transition name="fade">
                                                    <div  v-if="etatreceptionMissing" 
                                                        class="alert alert-danger" 
                                                        role="alert">
                                                        L'état réception est manquant.
                                                    </div>
                                                </transition>
                                            </div>
                                            <div class="col-lg-6">
                                                <base-input label="Etat Paiement"
                                                            input-classes="form-control-alternative"
                                                            :required="required">
                                                    <InputSelect :options="etatpaiement"
                                                                v-model="facture.idEtatPaiement"
                                                                textProp="label"
                                                                valueProp="idEtatPaiement"
                                                                :searchable="searchable"
                                                                class="form-control form-control-alternative"/>
                                                </base-input>
                                                <transition name="fade">
                                                    <div  v-if="etatpaiementMissing" 
                                                        class="alert alert-danger" 
                                                        role="alert">
                                                        L'état paiement est manquant.
                                                    </div>
                                                </transition>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="my-4" />
                                    <base-button v-on:click="submitForm" type="success col-lg-12">Modifier cette facture</base-button><br><br>
                                    <transition name="fade">
                                        <div  v-if="errorfacture" 
                                            class="alert alert-danger" 
                                            role="alert">
                                            Problème lors de la modification...
                                        </div>
                                        <div  v-if="goodfacture" 
                                            class="alert alert-success" 
                                            role="alert">
                                            Facture modifiée
                                        </div>
                                    </transition>
                                </form>
                            </template>
                        </card><br>
                    </div>
                    <div class="col-lg-6">
                        <div class="row">
                            <div class="col-lg-12">
                                <card shadow type="secondary">
                                    <div slot="header" class="bg-white border-0">
                                        <div class="row align-items-center">
                                            <div class="col-8">
                                                <h3 class="mb-0">Commentaires</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <template>
                                        <center><div v-if="loadingCommentaire" class="lds-ring"><div></div><div></div><div></div><div></div></div></center>
                                        <vue-horizontal-timeline v-if="!loading" v-on:TimelineTrashClicked="RemoveCommentaire" :items="CommentaireItems"/>
                                        <br>
                                        <form @submit.prevent>
                                            <div class="col-lg-12">
                                                <div class="row" >
                                                    <div class="col-lg-6">
                                                        <base-input alternative=""
                                                                placeholder="Commentaire"
                                                                input-classes="form-control-alternative"
                                                                :required="required"
                                                                v-model="commentaireToAdd.commentaire"/>
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <base-button v-on:click="AddCommentaire" type="success">Ajouter ce commentaire</base-button><br><br>
                                                    </div>
                                                </div>
                                                <transition name="fade">
                                                    <div  v-if="commentaireMissing" 
                                                        class="alert alert-danger" 
                                                        role="alert">
                                                        Le commentaire ne peut être vide.
                                                    </div>
                                                </transition>
                                            </div>
                                        </form>
                                    </template>
                                </card>
                            </div>
                        </div><br>
                        <div class="row">
                            <div class="col-lg-12">
                                <card shadow type="secondary">
                                    <div slot="header" class="bg-white border-0">
                                        <div class="row align-items-center">
                                            <div class="col-8">
                                                <h3 class="mb-0">Facture(s) liée(s)</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <template>
                                        <center><div v-if="loadingFactureLiee" class="lds-ring"><div></div><div></div><div></div><div></div></div></center>
                                        <transition name="fade">
                                            <div  v-if="facturesliees.length==0 && !loading" 
                                                class="alert alert-danger" 
                                                role="alert">
                                                Il n'y a rien à afficher
                                            </div>
                                        </transition>
                                        <div v-if="!loading" class="list-group">
                                            <div class="list-group-item list-group-item-action"
                                                v-for="factureliee in facturesliees" 
                                                :key="factureliee.idFacture">
                                                    <a href="#" 
                                                    @click.prevent="DownloadFactureLiee(factureliee.idFacture)">
                                                            {{factureliee.nameFile}}
                                                    </a>
                                                    <a  href="#"
                                                        @click.prevent="RemoveFactureLiee(factureliee.idLiaisonFacture)"
                                                        class="float-right">
                                                            <i class="fa fa-trash-alt"></i>
                                                    </a>
                                            </div>
                                        </div>
                                        <br>
                                        <form @submit.prevent>
                                            <div class="col-lg-12">
                                                <div class="row">
                                                    <div class="col-lg-6">
                                                        <base-input input-classes="form-control-alternative"
                                                                    :required="required">
                                                            <InputSelect :options="allfactures"
                                                                         v-model="liaisonfactureToAdd"
                                                                         textProp="nom_for_select"
                                                                         valueProp="idFacture"
                                                                         :searchable="searchable"
                                                                         class="form-control form-control-alternative"/>
                                                        </base-input>
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <base-button v-on:click="AddFactureLiee" type="success">Ajouter cette liaison</base-button><br>
                                                    </div>
                                                </div>
                                                <transition name="fade">
                                                    <div  v-if="liaisonFactureMissing" 
                                                        class="alert alert-danger" 
                                                        role="alert">
                                                        La facture liée ne peut être vide.
                                                    </div>
                                                </transition>
                                            </div>
                                        </form>
                                    </template>
                                </card>
                            </div>
                        </div><br>
                        <div class="row">
                            <div class="col-lg-12">
                                <card shadow type="secondary">
                                    <div slot="header" class="bg-white border-0">
                                        <div class="row align-items-center">
                                            <div class="col-8">
                                                <h3 class="mb-0">Bons de livraison</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <template>
                                        <center><div v-if="loadingBonLivraison" class="lds-ring"><div></div><div></div><div></div><div></div></div></center>
                                        <transition name="fade">
                                            <div  v-if="bonsLivraison.length==0 && !loading" 
                                                class="alert alert-danger" 
                                                role="alert">
                                                Il n'y a rien à afficher
                                            </div>
                                        </transition>
                                        <div v-if="!loading" class="list-group">
                                            <div class="list-group-item list-group-item-action"
                                                v-for="bl in bonsLivraison" 
                                                :key="bl.idBonLivraison">
                                                    <a href="#" 
                                                    @click.prevent="DownloadBl(bl.idBonLivraison)">
                                                            {{bl.nameFile}}
                                                    </a>
                                                    <a  href="#"
                                                        @click.prevent="RemoveBl(bl.idBonLivraison)"
                                                        class="float-right">
                                                            <i class="fa fa-trash-alt"></i>
                                                    </a>
                                            </div>
                                        </div>
                                        <br>
                                        <form @submit.prevent>
                                            <div class="col-lg-12">
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <base-input :required="required" style="margin-bottom:0">
                                                            <InputFile v-on:input="handleFileChange" v-model="fileBl"></InputFile>
                                                        </base-input>
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <base-button v-on:click="AddBl" type="success">Ajouter ce bon de livraison</base-button><br>
                                                    </div>
                                                </div>
                                                <transition name="fade">
                                                    <div  v-if="bonlivraisonMissing" 
                                                        class="alert alert-danger" 
                                                        role="alert">
                                                        Le bon de livraison ne peut être vide.
                                                    </div>
                                                </transition>
                                            </div>
                                        </form>
                                    </template>
                                </card>
                            </div>
                        </div><br>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import constvar from '@/const'
import modal from "@/components/Modal";
import _ from 'lodash'
import router from '@/router'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import InputSelect from '@alfsnd/vue-bootstrap-select'
import VueHorizontalTimeline from '@/components/HorizontalTimeLine'
import InputFile from "@/components/InputFile";
 

export default {
    name: "FactureEditModal",
    components: {
        modal,
        InputFile,
        flatPicker,
        InputSelect,
        VueHorizontalTimeline,
    },
    props: {
        facture: {
            type: Object,
            default: () => [
                {numero: ''},
                {date: ''},
                {montantHT: ''},
                {montantTTC: ''},
                {dateReglementMax: ''},
                {dateReglement: ''},
                {nameFile: ''},
                {contentFile: ''},
                {idFournisseur: ''},
                {idDevise: ''},
                {idEtatPaiement: ''},
                {idEtatReception: ''}
            ],
            description: "Facture object"
        },
        devise: {
            type: Array,
            default: () => [
                {idDevise: ''},
                {nom: ''},
                {symbole: ''},
            ]
        },
        fournisseur: {
            type: Array,
            default: () => [
                {idFournisseur: ''},
                {nom: ''},
                {emailContact: ''},
                {prenomContact: ''},
                {nomContact: ''},
            ]
        },
        etatreception: {
            type: Array,
            default: () => [
                {idEtatReception: ''},
                {label: ''},
            ]
        },
        etatpaiement: {
            type: Array,
            default: () => [
                {idEtatPaiement: ''},
                {label: ''},
            ]
        }
    },
    data() {
      return {
        modalAdd: false,
        required: true,
        errorfacture: false,
        goodfacture: false,
        file: null,
        numeroMissing: 0,
        dateMissing: 0,
        montanthtMissing: 0,
        montantttcMissing: 0,
        reglementmaxMissing: 0,
        fournisseurMissing: 0,
        etatpaiementMissing: 0,
        etatreceptionMissing: 0,
        deviseMissing: 0,
        commentaireMissing: 0,
        bonlivraisonMissing: 0,
        liaisonFactureMissing: 0,
        modalEdit: false,
        searchable:true,
        factureentiere: [],
        CommentaireItems: [],
        commentaireToAdd: [],
        bonsLivraison: [],
        facturesliees: [],
        allfactures: [],
        loading: 1,
        loadingCommentaire: 1,
        loadingBonLivraison: 1,
        loadingFactureLiee: 1,
        bonlivraison: [],
        fileBl: null,
        liaisonfactureToAdd: 0,
      }
    },
    created() {
    },
    methods: {
        handleFileChange(file) {
            this.bonlivraison.contentFile = file
            this.bonlivraison.nameFile = file.name
        },
        async submitForm() {
            if(!this.facture.numero) { this.numeroMissing = 1 } else { this.numeroMissing = 0 }
            if(!this.facture.date) { this.dateMissing = 1 } else { this.dateMissing = 0 }
            if(!this.facture.montantHT) { this.montanthtMissing = 1 } else { this.montanthtMissing = 0 }
            if(!this.facture.montantTTC) { this.montantttcMissing = 1 } else { this.montantttcMissing = 0 }
            if(!this.facture.dateReglementMax) { this.reglementmaxMissing = 1 } else { this.reglementmaxMissing = 0 }
            if(!this.facture.idFournisseur) { this.fournisseurMissing = 1 } else { this.fournisseurMissing = 0 }
            if(!this.facture.idEtatPaiement) { this.etatpaiementMissing = 1 } else { this.etatpaiementMissing = 0 }
            if(!this.facture.idEtatReception) { this.etatreceptionMissing = 1 } else { this.etatreceptionMissing = 0 }
            if(!this.facture.idDevise) { this.deviseMissing = 1 } else { this.deviseMissing = 0 }
            if(this.numeroMissing || this.dateMissing || this.montanthtMissing || this.montantttcMissing || this.reglementmaxMissing || this.fournisseurMissing || this.etatpaiementMissing || this.etatreceptionMissing || this.deviseMissing) { return; }

            this.facture.montantHT = String(this.facture.montantHT).replace(",", ".")
            this.facture.montantTTC = String(this.facture.montantTTC).replace(",", ".")
            this.facture.idFournisseur = this.facture.idFournisseur.idFournisseur;
            this.facture.idDevise = this.facture.idDevise.idDevise;
            this.facture.idEtatPaiement = this.facture.idEtatPaiement.idEtatPaiement;
            this.facture.idEtatReception = this.facture.idEtatReception.idEtatReception;
            const params = Object.keys(this.facture).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.facture[key])).join('&');

            const response = await fetch(constvar.api_url+'facture/'+this.facture.idFacture, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: params
            });
            const json = await response.json();
            if(json.rows == 1) {
                this.$emit('factureadded', true)
                this.modalEdit = false
            } else {
                this.errorfacture = true
                setTimeout(()=>{
                this.errorfacture = false
                },3000);
            } 
        },
        async ShowEdit() {
            this.modalEdit = true; 
            var self = this;
            this.fournisseur.forEach(function(element) {
                if(element.idFournisseur == self.facture.idFournisseur) {
                    self.facture.idFournisseur = element
                }
            })
            this.devise.forEach(function(element) {
                if(element.idDevise == self.facture.idDevise) {
                    self.facture.idDevise = element
                }
            })
            this.etatpaiement.forEach(function(element) {
                if(element.idEtatPaiement == self.facture.idEtatPaiement) {
                    self.facture.idEtatPaiement = element
                }
            })
            this.etatreception.forEach(function(element) {
                if(element.idEtatReception == self.facture.idEtatReception) {
                    self.facture.idEtatReception = element
                }
            })
            const factureentiere = await fetch(constvar.api_url+'facture_without_file/'+this.facture.idFacture, {
                method: 'GET',
                credentials: 'include',
            });
            if(factureentiere.ok) { 
                let factureentierejson = await factureentiere.json();
                
                if(factureentierejson.idFacture == this.facture.idFacture) {
                    
                    factureentierejson.commentaire = _.orderBy(factureentierejson.commentaire, "idCommentaire", "desc")
                    factureentierejson.bonlivraison = _.orderBy(factureentierejson.bonlivraison, "idBonLivraison", "desc") 
                    factureentierejson.factureLiees = _.orderBy(factureentierejson.factureLiees, "idFacture", "desc") 
                    this.factureentiere = factureentierejson;

                    self.CommentaireItems = []
                    this.factureentiere.commentaire.forEach(function(element) {
                        var commentaireToPush = {
                            idCommentaire: element.idCommentaire,
                            title: element.date,
                            content: element.commentaire
                        }
                        self.CommentaireItems.push(commentaireToPush)
                    })

                    self.bonsLivraison = []
                    this.factureentiere.bonlivraison.forEach(function(element) {
                        self.bonsLivraison.push(element)
                    })

                    self.facturesliees = []
                    this.factureentiere.factureLiees.forEach(function(element) {
                        self.facturesliees.push(element)
                    })
                } else { 
                    router.push("login")    
                }
            }
            self.allfactures = []
            const response = await fetch(constvar.api_url+'facture', {
            method: 'GET',
            credentials: 'include',
            });
            if(response.ok) { 
                const json = await response.json();
                //check if api return regenerated token
                if(json.code != 409) {
                    json.forEach(function(element) {
                        var canpush = true;
                        if(element.idFacture == self.facture.idFacture) {
                            canpush = false;
                        }
                        self.factureentiere.factureLiees.forEach(function(element2) {
                            if(element2.idFacture == element.idFacture) {
                                canpush = false;
                            }
                        })
                        if(canpush == true) {
                            self.allfactures.push(element);
                        }
                    })
                } else { 
                    router.push("login")    
                }
            } 
            this.loading=0; 
            this.loadingCommentaire=0; 
            this.loadingBonLivraison=0; 
            this.loadingFactureLiee=0; 
        },
        async AddCommentaire() {
            this.loadingCommentaire=1; 
            var self = this;
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0');
            var yyyy = today.getFullYear();

            today = yyyy + '-' + mm + '-' + dd;

            if(!this.commentaireToAdd.commentaire) { this.commentaireMissing = 1; return; } else { this.commentaireMissing = 0 }
            
            const params = new FormData();
            params.append('commentaire', this.commentaireToAdd.commentaire);
            params.append('date', today);
            params.append('idFacture', this.facture.idFacture);

    
            const response = await fetch(constvar.api_url+'commentaire', {
                method: 'POST',
                credentials: 'include',
                body: params
            });
            const json = await response.json();
            if(json.id) {
                const factureentiere = await fetch(constvar.api_url+'facture_without_file/'+this.facture.idFacture, {
                        method: 'GET',
                        credentials: 'include',
                    });
                    if(factureentiere.ok) { 
                        this.CommentaireItems = []
                        let factureentierejson = await factureentiere.json();
                        
                        if(factureentierejson.idFacture == this.facture.idFacture) {
                            
                            factureentierejson.commentaire = _.orderBy(factureentierejson.commentaire, "idCommentaire", "desc")
                            this.factureentiere = factureentierejson;
                            this.factureentiere.commentaire.forEach(function(element) {
                                var commentaireToPush = {
                                    idCommentaire: element.idCommentaire,
                                    title: element.date,
                                    content: element.commentaire
                                }
                                self.CommentaireItems.push(commentaireToPush)
                            })
                        } else { 
                            router.push("login")    
                        }
                    } 
            }
            this.loadingCommentaire=0; 

        },
        async AddBl() {
            var self = this;

            if(this.fileBl === null) { this.bonlivraisonMissing = 1; return; } else { this.bonlivraisonMissing = 0 }
            this.loadingBonLivraison=1; 
            
            const params = new FormData();
            params.append('nameFile', this.bonlivraison.nameFile);
            params.append('contentFile', this.bonlivraison.contentFile);
            params.append('idFacture', this.facture.idFacture);

    
            const response = await fetch(constvar.api_url+'bonlivraison', {
                method: 'POST',
                credentials: 'include',
                body: params
            });
            const json = await response.json();
            if(json.id) {
                this.fileBl = null
                const factureentiere = await fetch(constvar.api_url+'facture_without_file/'+this.facture.idFacture, {
                        method: 'GET',
                        credentials: 'include',
                    });
                    if(factureentiere.ok) { 
                        let factureentierejson = await factureentiere.json();
                        if(factureentierejson.idFacture == this.facture.idFacture) {
                            factureentierejson.bonlivraison = _.orderBy(factureentierejson.bonlivraison, "idBonLivraison", "desc") 
                            this.factureentiere = factureentierejson;

                            self.bonsLivraison = []
                            this.factureentiere.bonlivraison.forEach(function(element) {
                                self.bonsLivraison.push(element)
                            })
                        } else { 
                            router.push("login")    
                        }
                    } 
            }
            this.loadingBonLivraison=0;
        },
        async AddFactureLiee() {
            var self = this;

            if(this.liaisonfactureToAdd === null) { this.liaisonFactureMissing = 1; return; } else { this.liaisonFactureMissing = 0 }
            this.loadingLiaisonFacture=1; 
            
            const params = new FormData();
            params.append('idFacture', this.facture.idFacture);
            params.append('idFacture_liaisonFacture', this.liaisonfactureToAdd.idFacture);

    
            const response = await fetch(constvar.api_url+'liaisonfacture', {
                method: 'POST',
                credentials: 'include',
                body: params
            });
            const json = await response.json();
            if(json.id) {
                this.fileBl = null
                const factureentiere = await fetch(constvar.api_url+'facture_without_file/'+this.facture.idFacture, {
                        method: 'GET',
                        credentials: 'include',
                    });
                    if(factureentiere.ok) { 
                        let factureentierejson = await factureentiere.json();
                        if(factureentierejson.idFacture == this.facture.idFacture) {
                            factureentierejson.factureLiees = _.orderBy(factureentierejson.factureLiees, "idFacture", "desc") 
                            this.factureentiere = factureentierejson;

                            self.facturesliees = []
                            this.factureentiere.factureLiees.forEach(function(element) {
                                self.facturesliees.push(element)
                            })
                        } else { 
                            router.push("login")    
                        }
                    } 
            }
            this.allfactures = []
            const responseallfacture = await fetch(constvar.api_url+'facture', {
            method: 'GET',
            credentials: 'include',
            });
            if(responseallfacture.ok) { 
                const json = await responseallfacture.json();
                //check if api return regenerated token
                if(json.code != 409) {
                    json.forEach(function(element) {
                        var canpush = true;
                        if(element.idFacture == self.facture.idFacture) {
                            canpush = false;
                        }
                        self.factureentiere.factureLiees.forEach(function(element2) {
                            if(element2.idFacture == element.idFacture) {
                                canpush = false;
                            }
                        })
                        if(canpush == true) {
                            self.allfactures.push(element);
                        }
                    })
                } else { 
                    router.push("login")    
                }
            }
            this.liaisonfactureToAdd = null;
            this.loadingLiaisonFacture=0;
        },
        async RemoveCommentaire(commentaire) {
            var self = this;
            let options = {
                okText: 'Confirmer',
                cancelText: 'Annuler',
            };
            this.$dialog
            .confirm('Êtes vous sûr de vouloir supprimer ce commentaire ?', options)
            .then(async function() {
                self.loadingCommentaire=1; 
                const response = await fetch(constvar.api_url+'commentaire/'+commentaire.idCommentaire, {
                method: 'DELETE',
                credentials: 'include',
                });
                if(response.ok) { 
                    const json = await response.json();
                    //check if api return regenerated token
                    if(json.rows == 1) {
                        const factureentiere = await fetch(constvar.api_url+'facture_without_file/'+self.facture.idFacture, {
                            method: 'GET',
                            credentials: 'include',
                        });
                        if(factureentiere.ok) { 
                            let factureentierejson = await factureentiere.json();
                            
                            if(factureentierejson.idFacture == self.facture.idFacture) {
                                
                                factureentierejson.commentaire = _.orderBy(factureentierejson.commentaire, "idCommentaire", "desc")
                                self.factureentiere = factureentierejson;
                                self.CommentaireItems = []
                                self.factureentiere.commentaire.forEach(function(element) {
                                    var commentaireToPush = {
                                        idCommentaire: element.idCommentaire,
                                        title: element.date,
                                        content: element.commentaire
                                    }
                                    self.CommentaireItems.push(commentaireToPush)
                                })
                            } else { 
                                router.push("login")    
                            }
                        } 
                    } else { 
                        router.push("login")    
                    }
                } 
                self.loadingCommentaire=0; 
            })
        },
        async RemoveBl(idBonLivraison) {
            var self = this;
            let options = {
                okText: 'Confirmer',
                cancelText: 'Annuler',
            };
            this.$dialog
            .confirm('Êtes vous sûr de vouloir supprimer ce bon de livraison ?', options)
            .then(async function() {
                self.loadingBonLivraison=1; 
                const response = await fetch(constvar.api_url+'bonlivraison/'+idBonLivraison, {
                method: 'DELETE',
                credentials: 'include',
                });
                if(response.ok) { 
                    const json = await response.json();
                    //check if api return regenerated token
                    if(json.rows == 1) {
                        const factureentiere = await fetch(constvar.api_url+'facture_without_file/'+self.facture.idFacture, {
                            method: 'GET',
                            credentials: 'include',
                        });
                        if(factureentiere.ok) { 
                            let factureentierejson = await factureentiere.json();
                            if(factureentierejson.idFacture == self.facture.idFacture) {
                                factureentierejson.bonlivraison = _.orderBy(factureentierejson.bonlivraison, "idBonLivraison", "desc") 
                                self.factureentiere = factureentierejson;

                                self.bonsLivraison = []
                                self.factureentiere.bonlivraison.forEach(function(element) {
                                    self.bonsLivraison.push(element)
                                })
                            } else { 
                                router.push("login")    
                            }
                        } 
                    } else { 
                        router.push("login")    
                    }
                }
                self.loadingBonLivraison=0;  
            })
        },
        async RemoveFactureLiee(idLiaisonFacture) {
            var self = this;
            let options = {
                okText: 'Confirmer',
                cancelText: 'Annuler',
            };
            this.$dialog
            .confirm('Êtes vous sûr de vouloir supprimer cette liaison ?', options)
            .then(async function() {
                self.loadingFactureLiee=1; 
                const response = await fetch(constvar.api_url+'liaisonfacture/'+idLiaisonFacture, {
                method: 'DELETE',
                credentials: 'include',
                });
                if(response.ok) { 
                    const json = await response.json();
                    //check if api return regenerated token
                    if(json.rows == 1) {
                        const factureentiere = await fetch(constvar.api_url+'facture_without_file/'+self.facture.idFacture, {
                            method: 'GET',
                            credentials: 'include',
                        });
                        if(factureentiere.ok) { 
                            let factureentierejson = await factureentiere.json();
                            if(factureentierejson.idFacture == self.facture.idFacture) {
                                factureentierejson.factureLiees = _.orderBy(factureentierejson.factureLiees, "idFacture", "desc") 
                                self.factureentiere = factureentierejson;

                                self.facturesliees = []
                                self.factureentiere.factureLiees.forEach(function(element) {
                                    self.facturesliees.push(element)
                                })
                            } else { 
                                router.push("login")    
                            }
                        } 
                    } else { 
                        router.push("login")    
                    }
                }
                self.allfactures = []
                const responseallfacture = await fetch(constvar.api_url+'facture', {
                method: 'GET',
                credentials: 'include',
                });
                if(responseallfacture.ok) { 
                    const json = await responseallfacture.json();
                    //check if api return regenerated token
                    if(json.code != 409) {
                        json.forEach(function(element) {
                            var canpush = true;
                            if(element.idFacture == self.facture.idFacture) {
                                canpush = false;
                            }
                            self.factureentiere.factureLiees.forEach(function(element2) {
                                if(element2.idFacture == element.idFacture) {
                                    canpush = false;
                                }
                            })
                            if(canpush == true) {
                                self.allfactures.push(element);
                            }
                        })
                    } else { 
                        router.push("login")    
                    }
                }
                self.loadingFactureLiee=0;  
            })
        },
        async DownloadBl(idBonLivraison) {
            const bonlivraison = await fetch(constvar.api_url+'bonlivraison/'+idBonLivraison, {
              method: 'GET',
              credentials: 'include',
            });
            if(bonlivraison.ok) { 
              let bonlivraisonjson = await bonlivraison.json();
              if(bonlivraisonjson.idBonLivraison == idBonLivraison) {
                const linkSource = `data:application/pdf;base64,`+bonlivraisonjson.contentFile;
                const downloadLink = document.createElement("a");
                const fileName = bonlivraisonjson.nameFile;

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
              } else { 
                router.push("login")    
              }
            } 
        },
        async DownloadFactureLiee(idFactureLiee) {
            const facture = await fetch(constvar.api_url+'facture/'+idFactureLiee, {
              method: 'GET',
              credentials: 'include',
            });
            if(facture.ok) { 
              let facturejson = await facture.json();
              if(facturejson.idFacture == idFactureLiee) {
                const linkSource = `data:application/pdf;base64,`+facturejson.contentFile;
                const downloadLink = document.createElement("a");
                const fileName = facturejson.nameFile;

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
              } else { 
                router.push("login")    
              }
            } 
        },
    },
    watch: {
    }
};
</script>
<style>
    .style-chooser .vs__dropdown-toggle {
        border: none;
    }
    .v-select {
        height:calc(1.5em + 1.25rem + 2px)!important;
        padding:0!important;
    }
    .v-select-toggle {
        background-color:white!important;
        height:100%!important
    }
    .lds-ring {
        display: inline-block;
        position: relative;
        width: 64px;
        height: 64px;
        margin:auto
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 51px;
        height: 51px;
        margin: 6px;
        border: 6px solid black;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: rgb(146, 146, 146) transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>